import { 
  Table, 
  TableRow, 
  TableCell, 
  Paragraph, 
  TextRun, 
  BorderStyle, 
  WidthType 
} from 'docx'
import { processInlineFormatting } from '../processors/inlineFormatting'

/**
 * Create a table from headers and rows
 */
export function createTable(headers: string[], rows: string[][], font: string, fontSize: number): Table {
  const tableRows: TableRow[] = []
  
  // Create header row
  if (headers.length > 0) {
    const headerCells = headers.map(header => 
      new TableCell({
        children: [new Paragraph({
          children: [new TextRun({ 
            text: header, 
            bold: true, 
            font, 
            size: fontSize,
            color: '000000'
          })]
        })],
        borders: {
          top: { style: BorderStyle.SINGLE, size: 1 },
          bottom: { style: BorderStyle.SINGLE, size: 1 },
          left: { style: BorderStyle.SINGLE, size: 1 },
          right: { style: BorderStyle.SINGLE, size: 1 },
        }
      })
    )
    tableRows.push(new TableRow({ children: headerCells }))
  }
  
  // Create data rows
  rows.forEach(row => {
    const cells = row.map(cell => 
      new TableCell({
        children: [new Paragraph({
          children: processInlineFormatting(cell, font, fontSize)
        })],
        borders: {
          top: { style: BorderStyle.SINGLE, size: 1 },
          bottom: { style: BorderStyle.SINGLE, size: 1 },
          left: { style: BorderStyle.SINGLE, size: 1 },
          right: { style: BorderStyle.SINGLE, size: 1 },
        }
      })
    )
    tableRows.push(new TableRow({ children: cells }))
  })
  
  return new Table({
    rows: tableRows,
    width: {
      size: 100,
      type: WidthType.PERCENTAGE,
    },
  })
}